module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ExtraLight-f1016e2fe2b0344e1b24c5703f3419ea.otf";